import taxonomyService from '../main/taxonomyService'
import React, {Component} from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import API from '../config/API';
import { toast } from 'react-toastify';
import { injectIntl } from "react-intl";
import i18n from "../main/i18n";
import formTranslator from "../main/rjsf/formTranslator";
import EvidenceForm from "./form/EvidenceForm";
import { evidenceDataTransformer } from "../main/evidenceDataTransformer";
import { logUploadEvent } from "../components/UsageAnalytics";

class EvidenceSubmitter extends Component {

  constructor(props) {
    super(props);
    this.state = {submissionInProgress: false};

    const {serviceAreaId, evidenceTypeId} = props.match.params;
    this.serviceArea = taxonomyService.getServiceArea(serviceAreaId);
    this.evidenceType = taxonomyService.getEvidenceType(this.serviceArea, evidenceTypeId);

    this.isValidRoute = this.serviceArea && this.evidenceType;

    if (!this.isValidRoute) {
      return;
    }

    if (this.evidenceType.requiredEvidence) {
      this.evidenceGuidance = {
        title: this.evidenceType.requiredEvidence[0],
        list: []
      };

      const evidenceGuidanceLength = this.evidenceType.requiredEvidence.length;

      if (evidenceGuidanceLength > 1) {
        this.evidenceGuidance.list = this.evidenceType.requiredEvidence.slice(1, evidenceGuidanceLength);
      }
    }

    this.msg = i18n.getMsg(this.props.intl);
  }

  serverSubmit = result => {
    window.scrollTo(0, 0);
    this.setState({submissionInProgress: true});

    // Transform the data into the structure expected by the server
    const evidenceData = evidenceDataTransformer(result.formData, result.schema, this.serviceArea, this.evidenceType);

    API.scanStation.post('/evidence', evidenceData)
      .then(response => {
        console.log('Submission succeeded', response);
        const referenceNumber = response.data.reference;
        const notificationsSent = response.data.notifications.map(notification => notification.name);

        // log upload event when form has been successfully submitted;
        const pageCount = result.formData.images.length || 0;
        logUploadEvent(this.serviceArea, this.evidenceType, pageCount);

        // use .replace() instead of .push() to prevent the user navigating back to the submitted form
        this.props.history.replace({
          pathname: `${this.props.match.url}/success`,
          search: `?ref=${referenceNumber}&notifications=${notificationsSent}`
        })
      })
      .catch(error => {
        this.setState({submissionInProgress: false});
        console.error('Submission failed', error);
        toast.error(this.msg('evidence.notSubmitted'));
      });
  };

  render() {
    if (!this.isValidRoute) {
      return <Redirect to="/"/>;
    } else {
      const taxonomyForm = this.evidenceType.form || this.serviceArea.form;
      const evidenceFormModel = formTranslator(taxonomyForm, this.evidenceType, this.msg);

      return (
          <EvidenceForm uiSchema={evidenceFormModel.uiSchema}
                        schema={evidenceFormModel.schema}
                        validationMessages={evidenceFormModel.validationMessages}
                        validate={evidenceFormModel.formValidator}
                        onSubmit={this.serverSubmit}
                        submissionInProgress={this.state.submissionInProgress}
                        introText={evidenceFormModel.introText}
                        evidenceGuidance={this.evidenceGuidance}/>
      );
    }
  }
}

export default withRouter(injectIntl(EvidenceSubmitter));
